/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { IntermediariPa } from "./IntermediariPa";
import { PaStazionePa } from "./PaStazionePa";
import * as t from "io-ts";

// required attributes
const StazioniR = t.interface({});

// optional attributes
const StazioniO = t.partial({
  enabled: t.boolean,

  fkIntermediarioPa: t.Integer,

  flagOnline: t.boolean,

  flagStandin: t.boolean,

  idStazione: t.string,

  intermediarioPa: IntermediariPa,

  invioRtIstantaneo: t.boolean,

  ip: t.string,

  ip4Mod: t.string,

  isPaymentOptionsEnabled: t.boolean,

  numThread: t.Integer,

  objId: t.Integer,

  password: t.string,

  porta: t.Integer,

  porta4Mod: t.Integer,

  protocollo: t.string,

  protocollo4Mod: t.string,

  proxyEnabled: t.boolean,

  proxyHost: t.string,

  proxyPassword: t.string,

  proxyPort: t.Integer,

  proxyUsername: t.string,

  redirectIp: t.string,

  redirectPath: t.string,

  redirectPorta: t.Integer,

  redirectProtocollo: t.string,

  redirectQueryString: t.string,

  restEndpoint: t.string,

  rtEnabled: t.boolean,

  servizio: t.string,

  servizio4Mod: t.string,

  servizioNmp: t.string,

  servizioPof: t.string,

  targetHost: t.string,

  targetHostPof: t.string,

  targetPath: t.string,

  targetPathPof: t.string,

  targetPort: t.Integer,

  targetPortPof: t.Integer,

  timeoutA: t.Integer,

  timeoutB: t.Integer,

  timeoutC: t.Integer,

  versione: t.Integer,

  versionePrimitive: t.Integer
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: Stazioni, PaStazionePa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type Stazioni = t.TypeOf<typeof StazioniR> &
  t.TypeOf<typeof StazioniO> & {
  readonly "paStazionePaList"?: ReadonlyArray<PaStazionePa>;
  };

export const Stazioni: t.Type<Stazioni> = t.recursion("Stazioni", () =>
  t.intersection(
    [StazioniR, t.partial({ ...StazioniO.props, "paStazionePaList": t.readonlyArray(PaStazionePa, "array of PaStazionePa") })],
    "Stazioni"
  ) as unknown as t.Type<Stazioni>
);
